import type { ContextualColor, SecondaryColor } from '@/components/sgBootstrapReactWrapper';
import type { RootType } from '@/model/mappingCode/rootType';
import clsx from 'clsx';
import { FormattedMessage } from 'react-intl';

const colorForRootTypes: { [type in RootType]: ContextualColor | SecondaryColor } = {
  PP: 'cornflower-blue', // physical person
  PM: 'faded-jade', // moral person
  /* temporary, modify asap*/ PMB: 'faded-jade', // moral bank person
  /* temporary, modify asap*/ PI: 'faded-jade', // internal person
  /* temporary, modify asap*/ Di: 'faded-jade', // miscellaneous
};

type Props = {
  rootType: RootType;
  size?: 'md' | 'sd';
  pill?: boolean;
};

const RootTypeBadge = ({ rootType, size = 'md', pill = true }: Props) => {
  return (
    <div
      className={clsx('badge', `badge-${size}`, `badge-discreet-${colorForRootTypes[rootType]}`, {
        'rounded-pill': pill,
      })}
      data-e2e="root-entity-type"
    >
      <FormattedMessage id={`root.type.${String(rootType)}`} />
    </div>
  );
};

export default RootTypeBadge;
